<template>
  <v-app id="inspire">
    <v-app-bar app clipped-right color="blue-grey" dark :height="'36px'">
      <v-toolbar-title>
        График исполненного движения на участке
      </v-toolbar-title>
      <v-toolbar-items style="width: 350px; padding-left: 10px; padding-top: 4px;">
        <v-combobox v-model="selectedSection" :items="sections" :flat="true"></v-combobox>
      </v-toolbar-items>
      <div class="flex-grow-1">
      </div>
      <v-toolbar-items style="font-size: 14px; line-height:100%;">
        <v-btn @click="changeTimeStatus" style="margin-right: 5px;">
          <v-icon v-if="timeIsPlaying" >mdi-pause</v-icon>
          <v-icon v-else >mdi-play</v-icon>          
        </v-btn>
        <v-btn @click="right">Right</v-btn>
        <p>{{currentDateTimeFormated}}<br />ДНЦ Петров И.С.</p>
      </v-toolbar-items>
    </v-app-bar>
    <v-container class="fill-height" id="container">
      <v-row>
        <v-col class="shrink" id="column">
          <v-stage ref="canvas" :config="configKonva" id="main-canvas">
            <v-fast-layer ref="lineLayer">
              <v-line :config=topLineConfig></v-line>
              <v-line v-for="line in verticalLines" :key="line.points.toString()" :config="line"></v-line>
              <v-line v-for="line in horizontalLines" :key="line.points.toString()" :config="line"></v-line>

              <v-line :config="window"></v-line>
              <v-line :config="customWindow"></v-line>
              <v-line :config="speedLimitationTop"></v-line>
              <v-line :config="speedLimitationBottom"></v-line>
            </v-fast-layer>

            <v-layer ref="trainLayer">
              <v-text v-for="text in trainNames" :key="text.text + text.x + text.y" :config="text"></v-text>
              <v-line :config="fakePlanLine"></v-line>
              <v-line :config="timeLine"></v-line>
            </v-layer>
          </v-stage>

          <v-stage ref="leftCanvas" :config="configLeftKonva" id="left-canvas">
            <v-layer>
              <v-rect :config="leftKonvaBackgroundRect"></v-rect>
              <v-text v-for="text in horizontalText" :key="text.text" :config="text"></v-text>
            </v-layer>
          </v-stage>

          <v-stage ref="topCanvas" :config="configTopKonva" id="top-canvas">
            <v-layer>
              <v-rect :config="topKonvaBackgroundRect"></v-rect>
              <v-text v-for="text in verticalText" :key="text.dateTimeInTicks" :config="text"></v-text>
            </v-layer>
          </v-stage>

          <v-navigation-drawer v-if="!train56WasClicked" app clipped right :width="'300px'">
            <v-tabs :grow="true" id="rigth-tab">
              <v-tab style="font-size: 12px;">Приказы</v-tab>
              <v-tab style="font-size: 12px;">Селекторная связь</v-tab>
              <v-tab-item>
                <v-row>
                  <v-col>
                    <v-btn>Выдать приказ</v-btn>
                  </v-col>
                </v-row>
                <v-card max-width="344" class="mx-auto" :hover="true">
                  <v-card-title>Приказ №72</v-card-title>
                  <v-card-text>Приказ №72 на выдачу поездопредупреждения. 273км 2п не более 40км/ч</v-card-text>
                </v-card>
                <v-card max-width="344" class="mx-auto" :hover="true">
                  <v-card-title>Приказ №71</v-card-title>
                  <v-card-text>Приказ №71 на длинносоставный поезд. 73 усл. длина</v-card-text>
                </v-card>
                <v-card max-width="344" class="mx-auto" :hover="true">
                  <v-card-title>Приказ №70</v-card-title>
                  <v-card-text>Приказ №70 на ликвидацию опоздания. 7 минут</v-card-text>
                </v-card>
                <v-card max-width="344" class="mx-auto" :hover="true">
                  <v-card-title>Приказ №69</v-card-title>
                  <v-card-text>Приказ №69 о приеме поезда при запрещающем показании входного светофора ст. Нура
                  </v-card-text>
                </v-card>
              </v-tab-item>
              <v-tab-item>
                <v-tabs :grow="true">
                  <v-tab style="font-size: 12px;">На участке</v-tab>
                  <v-tab style="font-size: 12px;">НОД</v-tab>
                  <v-tab style="font-size: 12px;">В пути</v-tab>
                  <v-tab-item>
                    <div v-show="!chatIsActive" style="text-align: start;">
                      <v-treeview :activatable="true" :open-on-click="true" :items="onSectionList"
                        @click="chatIsActive = true">
                        <template v-slot:append="{item}">
                          <v-avatar v-if="!item.children && item.name !== 'ЭЧ Жахин Д'" class="rounded" :rounded="true"
                            tile size="10" color="green"></v-avatar>
                          <v-avatar v-if="item.name === 'ЭЧ Жахин Д'" class="rounded" :rounded="true" tile size="10"
                            color="yellow"></v-avatar>
                        </template>
                      </v-treeview>
                    </div>
                    <div v-show="chatIsActive" style="height: 50vh;">
                      <p>Петров: Приказ №1 на нагон</p>
                      <p>Принято!</p>
                      <v-layout align-end justify-end style="margin-top: 50vh;">
                        <v-row align-content="center">
                          <v-col>
                            <v-textarea hint="Введите текст сообщения" :auto-grow="true" :clearable="true"
                              :outlined="true"></v-textarea>

                            <v-btn class="mx-2" block dark large color="primary" @click="chatIsActive=false">
                              Отправить
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-layout>
                    </div>
                  </v-tab-item>
                  <v-tab-item style="font-size: 15px; text-align: start;">
                    <v-treeview :open-on-click="true" :items="nodeList">
                      <template v-slot:append="{item}">
                        <v-avatar v-if="!item.children && item.name !== 'ДНЦ Астана - Ерейментау'" class="rounded"
                          :rounded="true" tile size="10" color="green"></v-avatar>
                        <v-avatar v-if="item.name === 'ДНЦ Астана - Ерейментау'" class="rounded" :rounded="true" tile
                          size="10" color="yellow"></v-avatar>
                      </template>
                    </v-treeview>
                  </v-tab-item>
                  <v-tab-item style="font-size: 15px; text-align: start;">
                    <v-treeview :open-on-click="true" :items="inRouteList">
                    </v-treeview>
                  </v-tab-item>
                </v-tabs>
              </v-tab-item>
            </v-tabs>
          </v-navigation-drawer>
          <v-navigation-drawer v-if="train56WasClicked" app clipped right :width="'300px'">
            <div v-for="route in train56Route" :key="route.section">
              <p>{{route.section}}</p>
              <v-card v-for="station in route.stations" :key="station.stationName" max-width="344" class="mx-auto">
                <v-card-text
                  v-if="station.stationName === '690002 - Астана 1' || station.stationName === '690200 - Сороковая'"
                  style="font-size: 1rem; text-align: start; color: rgba(0, 0, 0, 1);">
                  {{new Date(station.departureTime).toTimeString().substring(0, 9).trim()}} {{station.stationName}}
                </v-card-text>
                <v-card-text v-else style="font-size: 1rem; text-align: start;">
                  {{new Date(station.departureTime).toTimeString().substring(0, 9).trim()}} {{station.stationName}}
                </v-card-text>
              </v-card>
            </div>
          </v-navigation-drawer>
        </v-col>
      </v-row>
    </v-container>
    <v-snackbar v-model="showSnackbar" :bottom="true" :color="'info'" :multi-line="true" :right="true">
      {{ snackbarText }}
      <v-btn dark text @click="showSnackbar = false">
        Закрыть
      </v-btn>
    </v-snackbar>
  </v-app>
</template>

<script>
  import Konva from 'konva'
  import moment from 'moment'

  export default {
    name: 'HelloWorld',
    mounted() {
      const html = $('html')

      const leftCanvas = html.find('#left-canvas')
      const topCanvas = html.find('#top-canvas')

      setInterval(() => {
        leftCanvas.css('left', html.scrollLeft())
        topCanvas.css('top', html.scrollTop())
      }, 100)

      this.$store.dispatch('startTime', this.timeUpdated)
      this.fillStations()
      this.tooltip = this.createTooltip()
      this.fillVerticalLines(this.verticalPadding)
      this.fillHorizontalLines(this.verticalPadding)
      this.fillTrains()
      this.$nextTick(this.drawTrains)
      this.$refs.canvas.getNode().findOne('#fake').hide()
      document.onkeydown = (event) => {
        if (this.lineEditingInProgress) {
          if (event.code === 'Escape') {
            this.cancelLineEditing()
          }
          if (event.code === 'Enter') {
            this.acceptLineEditing()
          }
        }
      }
    },
    data() {
      return {
        rightHided: false,
        showSnackbar: false,
        snackbarShowed: false,
        snackbarText: 'Опоздание проследования поезда #56 на 5 минут по ст. Сороковая',
        train56WasClicked: false,
        drawer: null,
        left: false,
        chatIsActive: false,
        currentDateTime: null,
        verticalPadding: 100,
        beginDateTicks: 1567209600000, //1_567_209_600_000
        endDateTicks: 1567641600000, //1_567_641_600_000
        ticksInHour: 3600000, //3_600_000
        ticksInTenMinutes: 600000, //600_000
        verticalLines: [],
        horizontalLines: [],
        verticalText: [],
        horizontalText: [],
        trainNames: [],
        trains: [],
        trainGroups: [],
        trainLines: [],
        tooltip: {},
        nodeList: [{
            id: 1,
            name: 'НОД Караганда',
            children: [{
                id: 2,
                name: 'НОД Игнашева Г'
              },
              {
                id: 3,
                name: 'НОДЗ Калашников В'
              },
              {
                id: 4,
                name: 'НОДГ Столяров Р'
              },
              {
                id: 5,
                name: 'НОДтех Затеев В'
              },
              {
                id: 6,
                name: 'УРБ Везенов Д'
              },
            ]
          },
          {
            id: 7,
            name: 'ДНЦ Караганда-Сорт - Агадырь Сушков А'
          },
          {
            id: 8,
            name: 'ДНЦ Агадырь - Сарышаган Шваб А'
          },
          {
            id: 9,
            name: 'ДНЦ  Жарык - Жезгазкан Байкемелов С'
          },
          {
            id: 10,
            name: 'ДНЦ Мойынты - Балхаш Васильченко Н'
          },
          {
            id: 11,
            name: 'НОД Акмолинский',
            children: [{
                id: 12,
                name: 'НОД Бруева А'
              },
              {
                id: 13,
                name: 'НОДЗ Дуболеко А'
              },
              {
                id: 14,
                name: 'НОДГ Гончарова Е'
              },
              {
                id: 15,
                name: 'НОДтех Задворнова Д'
              },
              {
                id: 16,
                name: 'УРБ Дудинов Р'
              },
            ]
          },
          {
            id: 17,
            name: 'ДНЦ Астана - Ерейментау Новикова В'
          },
          {
            id: 18,
            name: 'ДНЦ Астана - Атбасар Виноградова Н'
          },
          {
            id: 19,
            name: 'ДНЦ Астана - Курорт-Боровое Григорьев А'
          },
        ],
        inRouteList: [{
            id: 1,
            name: '№2013 ТЧМ Иванов П.Т. ВЛ80с-1255',
            children: [{
                id: 2,
                name: 'Приказ №71 на длинносоставный поезд. 73 усл. длина'
              },
              {
                id: 3,
                name: 'Приказ №72 на выдачу поездопредупреждения. 273км 2п не более 40км/ч'
              },
            ]
          },
          {
            id: 4,
            name: '№74 ТЧМ Тимуров А.К. KZ4a-0021',
            children: [{
              id: 5,
              name: 'Приказ №70 на ликвидацию опоздания. 7 минут'
            }, ]
          },
          {
            id: 6,
            name: '№1009 ТЧМ Ким Н.С. KZ8a-0034',
            children: [{
              id: 7,
              name: 'Приказ №69 о приеме поезда при запрещающем показании входного светофора ст. Нура'
            }, ]
          },
        ],
        onSectionList: [{
            id: 1,
            name: 'ТЧЭ-11 Астана',
            children: [{
                id: 2,
                name: 'ТЧЗэ Иванов И'
              },
              {
                id: 3,
                name: 'ТЧЭр Петрова Н'
              },
              {
                id: 4,
                name: 'ТЧД Абишев М'
              },
              {
                id: 5,
                name: 'ТЧН Шабанов И'
              },
            ]
          },
          {
            id: 6,
            name: 'УПЧ-17 Астана',
            children: [{
                id: 7,
                name: 'ПЧ Кабиева С'
              },
              {
                id: 8,
                name: 'ПЧГ Кугай Е'
              },
              {
                id: 9,
                name: 'ПЧД Уросова В'
              },
            ]
          },
          {
            id: 10,
            name: 'ЭЧ-8 Астана',
            children: [{
                id: 11,
                name: 'ЭЧ Жахин Д'
              },
              {
                id: 12,
                name: 'ЭЧГ Морозов Н'
              },
              {
                id: 13,
                name: 'ЭЧД Князев М'
              },
            ]
          },
          {
            id: 14,
            name: 'ШЧ-16 Астана',
            children: [{
                id: 15,
                name: 'ШЧ Назаров П'
              },
              {
                id: 16,
                name: 'ШЧГ Михальченко Т'
              },
              {
                id: 17,
                name: 'ШЧД Умирзакова А'
              },
            ]
          },
          {
            id: 19,
            name: 'Астана',
            children: [{
                id: 20,
                name: 'ДС Исмагулов Г'
              },
              {
                id: 21,
                name: 'ДСЗ Лернер В'
              },
              {
                id: 22,
                name: 'ДСП Алиева М'
              },
            ]
          },
          {
            id: 24,
            name: 'Сороковая',
            children: [{
                id: 25,
                name: 'ДС Сарсенбаева А'
              },
              {
                id: 26,
                name: 'ДСЗ Алиев Э'
              },
              {
                id: 27,
                name: 'ДСП Картаева Е'
              },
            ]
          },
          {
            id: 29,
            name: 'Мырза',
            children: [{
                id: 30,
                name: 'ДС Прокофьева Э'
              },
              {
                id: 31,
                name: 'ДСЗ Шаймерденов К'
              },
              {
                id: 32,
                name: 'ДСП Кожевников А'
              },
            ]
          },
          {
            id: 34,
            name: 'Нура',
            children: [{
                id: 35,
                name: 'ДС Шифонова А'
              },
              {
                id: 36,
                name: 'ДСЗ Репалова А'
              },
              {
                id: 37,
                name: 'ДСП Волчемисов В'
              },
            ]
          },
          {
            id: 39,
            name: 'Караганда-Сортировочная',
            children: [{
                id: 40,
                name: 'ДС Дёмина Н'
              },
              {
                id: 41,
                name: 'ДСЗ Щелоков Д'
              },
              {
                id: 42,
                name: 'ДСП Сухонина Н'
              },
            ]
          },
        ],
        lineEditingInProgress: false,
        windowEditingInProgress: false,
        topLineConfig: {},
        fakePlanLine: {
          points: [2373, 50, 2395, 233],
          dash: [10, 5],
          stroke: 'red',
          strokeWidth: 2,
          id: 'fake'
        },
        speedLimitationTop: {
          points: [
            2200, 100,
            2500, 100,
          ],
          stroke: 'black',
          strokeWidth: 2,
          dash: [10, 5]
        },
        speedLimitationBottom: {
          points: [
            2200, 105,
            2500, 105,
          ],
          stroke: 'black',
          strokeWidth: 2,
          dash: [10, 5]
        },
        window: {
          points: [
            /*Левый верхний угол*/
            2460, 320,
            /*Левый нижний угол*/
            2500, 562,
            /*Правый нижний угол*/
            2640, 562,
            /*Правый верхний угол*/
            2600, 320,
            /*Левый верхний угол*/
            2460, 320
          ],
          stroke: '#f1e343',
          strokeWidth: 2.5
        },
        customWindow: {
          points: [],
          stroke: 'red',
          strokeWidth: 5
        },
        editor: {
          previousLine: {
            index: 0,
            line: {}
          },
          currentLine: {
            index: 0,
            line: {}
          },
          nextLine: {
            index: 0,
            line: {}
          }
        },
        timeLine: {
          points: [0, 0, 0, 0],
          stroke: 'blue',
          strokeWidth: 3
        },
        configKonva: {
          width: 2500 * 2,
          height: 2200 * 1.5
        },
        configLeftKonva: {
          width: 200,
          height: 2200 * 1.5
        },
        configTopKonva: {
          width: 2500 * 2,
          height: 200
        },
        leftKonvaBackgroundRect: {
          x: 0,
          y: 0,
          fill: 'white',
          width: 100,
          height: 2200 * 1.5
        },
        topKonvaBackgroundRect: {
          x: 0,
          y: 0,
          fill: 'white',
          width: 2500 * 2,
          height: 30
        },
        section: {
          name: 'Караганда-Сортировочная - Астана 1',
          stations: [],
          length: 214.21
        },
        timeIsPlaying: true,
        sections: ['Караганда-Сортировочная - Астана 1',
          'Астана - Атбасар',
          'Караганда-Сорт - Агадырь',
          'Агадырь - Сарышаган',
          'Жарык - Жезгазкан',
          'Мойынты - Балхаш',
          'Астана - Ерейментау',
          'Астана - Атбасар',
          'Астана - Курорт-Боровое'
        ],
        selectedSection: 'Караганда-Сортировочная - Астана 1',
        train56Route: [{
          section: 'Астана 1 - Караганда-Сортировочная',
          stations: [{
            "departureTime": "2019-08-31T22:43:01",
            "stationName": "690002 - Астана 1"
          }, {
            "departureTime": "2019-08-31T23:02:22",
            "stationName": "690200 - Сороковая"
          }, {
            "departureTime": "2019-08-31T23:24:52",
            "stationName": "690229 - Обг. Пункт № 42"
          }, {
            "departureTime": "2019-08-31T23:34:17",
            "stationName": "690303 - Бабатай"
          }, {
            "departureTime": "2019-08-31T23:42:00",
            "stationName": "690318 - Шептыкуль "
          }, {
            "departureTime": "2019-08-31T23:48:37",
            "stationName": "690407 - Аршалы"
          }, {
            "departureTime": "2019-08-31T23:58:07",
            "stationName": "673327 - ОП 571 км"
          }, {
            "departureTime": "2019-09-01T00:06:37",
            "stationName": "690500 - Анар"
          }, {
            "departureTime": "2019-09-01T00:19:07",
            "stationName": "673609 - Сарыбел"
          }, {
            "departureTime": "2019-09-01T00:36:15",
            "stationName": "673505 - Актасты"
          }, {
            "departureTime": "2019-09-01T00:55:37",
            "stationName": "673401 - Шокай"
          }, {
            "departureTime": "2019-09-01T01:08:07",
            "stationName": "673420 - Астаховка"
          }, {
            "departureTime": "2019-09-01T01:16:45",
            "stationName": "673308 - Мырза"
          }, {
            "departureTime": "2019-09-01T01:23:22",
            "stationName": "673204 - Нура"
          }, {
            "departureTime": "2019-09-01T01:29:22",
            "stationName": "673219 - ПП №496"
          }, {
            "departureTime": "2019-09-01T01:35:07",
            "stationName": "673261 - Пп. 696 км"
          }, {
            "departureTime": "2019-09-01T01:42:52",
            "stationName": "673223 - Кокпекты"
          }]
        }, {
          section: 'Караганда-Сортировочная - Акадыр',
          stations: [{
            "departureTime": "2019-09-01T02:07:45",
            "stationName": "673007 - Караганда-Сортировочная"
          }, {
            "departureTime": "2019-09-01T02:13:45",
            "stationName": "673702 - Жана Караганды"
          }, {
            "departureTime": "2019-09-01T02:21:15",
            "stationName": "673806 - Май-Кудук"
          }, {
            "departureTime": "2019-09-01T02:43:42",
            "stationName": "673905 - Караганды"
          }, {
            "departureTime": "2019-09-01T02:51:22",
            "stationName": "675303 - Караганозек"
          }, {
            "departureTime": "2019-09-01T03:07:00",
            "stationName": "675407 - Карабас"
          }, {
            "departureTime": "2019-09-01T03:12:07",
            "stationName": "673276 - Обгонный пункт 767 км"
          }, {
            "departureTime": "2019-09-01T03:19:45",
            "stationName": "675411 - Чурбай-Нура"
          }, {
            "departureTime": "2019-09-01T03:25:30",
            "stationName": "675708 - Калагир"
          }, {
            "departureTime": "2019-09-01T03:36:30",
            "stationName": "675801 - Карамурын"
          }, {
            "departureTime": "2019-09-01T03:52:00",
            "stationName": "676109 - Дария"
          }, {
            "departureTime": "2019-09-01T04:06:00",
            "stationName": "675731 - Бурма (бп)"
          }, {
            "departureTime": "2019-09-01T04:14:09",
            "stationName": "675905 - Жарык"
          }, {
            "departureTime": "2019-09-01T04:32:22",
            "stationName": "675924 - Нилды"
          }, {
            "departureTime": "2019-09-01T04:44:45",
            "stationName": "675939 - Айса"
          }, {
            "departureTime": "2019-09-01T04:58:37",
            "stationName": "675943 - Тагайлы"
          }],
        }, {
          section: 'Акадыр - Сары-шаган',
          stations: [{
            "departureTime": "2019-09-01T05:20:26",
            "stationName": "677205 - Акадыр"
          }, {
            "departureTime": "2019-09-01T05:42:07",
            "stationName": "677211 - Донгал"
          }, {
            "departureTime": "2019-09-01T05:55:52",
            "stationName": "677224 - Босага"
          }, {
            "departureTime": "2019-09-01T06:28:30",
            "stationName": "677239 - Акшагыл"
          }, {
            "departureTime": "2019-09-01T06:42:22",
            "stationName": "679501 - Киик"
          }, {
            "departureTime": "2019-09-01T07:51:15",
            "stationName": "677309 - Мойынты"
          }, {
            "departureTime": "2019-09-01T08:02:37",
            "stationName": "705621 - Шешенкара"
          }, {
            "departureTime": "2019-09-01T08:16:53",
            "stationName": "705617 - Каражингил"
          }, {
            "departureTime": "2019-09-01T08:34:24",
            "stationName": "705602 - Весна"
          }, {
            "departureTime": "2019-09-01T08:49:15",
            "stationName": "705528 - Новалы"
          }],
        }, {
          section: 'Сары-шаган - Шу',
          stations: [{
            "departureTime": "2019-09-01T09:27:56",
            "stationName": "705509 - Сары-Шаган"
          }, {
            "departureTime": "2019-09-01T09:41:00",
            "stationName": "705405 - Коктас"
          }, {
            "departureTime": "2019-09-01T10:00:45",
            "stationName": "705354 - Кашкантениз"
          }, {
            "departureTime": "2019-09-01T10:19:07",
            "stationName": "705344 - Жастар (рзд)"
          }, {
            "departureTime": "2019-09-01T10:33:54",
            "stationName": "705706 - Мын-Арал"
          }, {
            "departureTime": "2019-09-01T11:01:37",
            "stationName": "705316 - Кайратколь"
          }, {
            "departureTime": "2019-09-01T11:15:25",
            "stationName": "705301 - Шыганак"
          }, {
            "departureTime": "2019-09-01T11:33:52",
            "stationName": "705265 - Бурубайтал"
          }, {
            "departureTime": "2019-09-01T11:44:52",
            "stationName": "705250 - Кара-Cай"
          }, {
            "departureTime": "2019-09-01T11:56:30",
            "stationName": "705227 - ОП 1390 км."
          }, {
            "departureTime": "2019-09-01T12:05:53",
            "stationName": "705208 - Кияхты"
          }, {
            "departureTime": "2019-09-01T12:40:59",
            "stationName": "704900 - Хантау"
          }, {
            "departureTime": "2019-09-01T12:46:37",
            "stationName": "704953 - ОП 1450 км."
          }, {
            "departureTime": "2019-09-01T12:55:52",
            "stationName": "704949 - ОП 1465 км."
          }, {
            "departureTime": "2019-09-01T13:00:15",
            "stationName": "704920 - Жидели"
          }, {
            "departureTime": "2019-09-01T13:06:52",
            "stationName": "704934 - ОП 1482 км."
          }, {
            "departureTime": "2019-09-01T13:18:52",
            "stationName": "704718 - Путевой Пост 1502 км"
          }, {
            "departureTime": "2019-09-01T13:22:00",
            "stationName": "704703 - Берлик I"
          }],
        }, {
          section: 'Шу - Тараз',
          stations: [{
            "departureTime": "2019-09-01T13:45:31",
            "stationName": "704600 - Шу"
          }, {
            "departureTime": "2019-09-01T14:02:07",
            "stationName": "704578 - ОП Кумозек"
          }, {
            "departureTime": "2019-09-01T14:14:22",
            "stationName": "704534 - Аспара"
          }, {
            "departureTime": "2019-09-01T14:26:15",
            "stationName": "704563 - ОП Тасоткель"
          }, {
            "departureTime": "2019-09-01T14:39:55",
            "stationName": "704525 - Татты"
          }, {
            "departureTime": "2019-09-01T14:51:15",
            "stationName": "704559 - ОП 3674 км."
          }, {
            "departureTime": "2019-09-01T15:09:07",
            "stationName": "704510 - Курагаты"
          }, {
            "departureTime": "2019-09-01T15:43:15",
            "stationName": "704506 - Луговая"
          }, {
            "departureTime": "2019-09-01T15:57:00",
            "stationName": "707487 - ОП 3615 км."
          }, {
            "departureTime": "2019-09-01T16:11:07",
            "stationName": "707504 - Малдыбай"
          }, {
            "departureTime": "2019-09-01T16:27:22",
            "stationName": "707400 - Акыр-Тюбе"
          }, {
            "departureTime": "2019-09-01T16:45:52",
            "stationName": "707307 - Акшолак"
          }, {
            "departureTime": "2019-09-01T17:03:45",
            "stationName": "707203 - Ушбулак"
          }, {
            "departureTime": "2019-09-01T17:16:38",
            "stationName": "707107 - Талас"
          }]
        }, {
          section: 'Тараз - Арысь II',
          stations: [{
            "departureTime": "2019-09-01T17:42:50",
            "stationName": "706304 - Тараз"
          }, {
            "departureTime": "2019-09-01T17:55:45",
            "stationName": "706200 - Кумшагал (рзд)"
          }, {
            "departureTime": "2019-09-01T18:04:30",
            "stationName": "706107 - Шолдала"
          }, {
            "departureTime": "2019-09-01T18:13:07",
            "stationName": "706018 - Жуантобе"
          }, {
            "departureTime": "2019-09-01T18:20:22",
            "stationName": "706003 - Маймак"
          }, {
            "departureTime": "2019-09-01T18:24:52",
            "stationName": "705960 - ОП 3474 км."
          }, {
            "departureTime": "2019-09-01T18:31:00",
            "stationName": "705922 - Куркуреу-Су"
          }, {
            "departureTime": "2019-09-01T18:35:00",
            "stationName": "705956 - ОП 3462 км."
          }, {
            "departureTime": "2019-09-01T18:39:00",
            "stationName": "705918 - Сурум"
          }, {
            "departureTime": "2019-09-01T18:43:52",
            "stationName": "705941 - ОП 3451 км."
          }, {
            "departureTime": "2019-09-01T18:55:04",
            "stationName": "705903 - Боранды"
          }, {
            "departureTime": "2019-09-01T19:02:22",
            "stationName": "704436 - ОП 3434 км."
          }, {
            "departureTime": "2019-09-01T19:10:37",
            "stationName": "699774 - Чокпак"
          }, {
            "departureTime": "2019-09-01T19:18:15",
            "stationName": "704417 - ОП 3409 км."
          }, {
            "departureTime": "2019-09-01T19:28:52",
            "stationName": "699740 - Обг. Пункт № 115"
          }, {
            "departureTime": "2019-09-01T19:35:00",
            "stationName": "699632 - Елтай"
          }, {
            "departureTime": "2019-09-01T19:38:45",
            "stationName": "699628 - ОП 3384 км."
          }, {
            "departureTime": "2019-09-01T19:55:42",
            "stationName": "699702 - Тюлькубас"
          }, {
            "departureTime": "2019-09-01T20:07:37",
            "stationName": "699609 - Коктерек"
          }, {
            "departureTime": "2019-09-01T20:14:22",
            "stationName": "697637 - Каракчи"
          }, {
            "departureTime": "2019-09-01T20:24:15",
            "stationName": "660908 - Менлибай"
          }, {
            "departureTime": "2019-09-01T20:30:30",
            "stationName": "699505 - Сас-Тобе"
          }, {
            "departureTime": "2019-09-01T20:36:52",
            "stationName": "699401 - Ынтымак"
          }, {
            "departureTime": "2019-09-01T20:41:45",
            "stationName": "697622 - Машат"
          }, {
            "departureTime": "2019-09-01T21:04:01",
            "stationName": "699308 - Манкент"
          }, {
            "departureTime": "2019-09-01T21:18:00",
            "stationName": "699204 - Кызылсай"
          }, {
            "departureTime": "2019-09-01T21:45:54",
            "stationName": "698606 - Шымкент"
          }, {
            "departureTime": "2019-09-01T21:56:52",
            "stationName": "698502 - Коргасын"
          }, {
            "departureTime": "2019-09-01T22:01:07",
            "stationName": "698540 - ОП 3278 км."
          }, {
            "departureTime": "2019-09-01T22:05:52",
            "stationName": "696808 - Игилик (рзд)"
          }, {
            "departureTime": "2019-09-01T22:08:45",
            "stationName": "698536 - ОП 3269 км."
          }, {
            "departureTime": "2019-09-01T22:15:00",
            "stationName": "698413 - ОП 3259 км."
          }, {
            "departureTime": "2019-09-01T22:19:52",
            "stationName": "698409 - Бадам"
          }, {
            "departureTime": "2019-09-01T22:35:45",
            "stationName": "698057 - Калаш"
          }, {
            "departureTime": "2019-09-01T22:40:30",
            "stationName": "698061 - ОП 3229 км."
          }, {
            "departureTime": "2019-09-01T22:42:22",
            "stationName": "698042 - ОП 3227 км."
          }, {
            "departureTime": "2019-09-01T23:04:27",
            "stationName": "698019 - Арыс II"
          }]
        }]
      };
    },
    computed: {
      fullDayHour: function () {
        return this.verticalPadding * 24
      },
      sectionDistance: function () {
        return this.section.stations.map(s => s.from).reduce((p, c) => p + c, 0)
      },
      currentDateTimeFormated: function () {
        if (this.currentDateTime == null) {
          return ''
        }

        return `${this.currentDateTime.toTimeString().substr(0, 9).trim()} ${this.currentDateTime.toLocaleDateString()}`
      }
    },
    methods: {
      right(){
        const node = this.$refs.trainLayer.getNode()

        if (this.rightHided){
          const childrens = node.children.forEach((c) => {
            if (c.nodeType === 'Group'){
                c.children.forEach((ch) => ch.show())
            } else {
              c.show()
            }
          })
          node.draw()
          this.rightHided = !this.rightHided
          return
        }

        const childrens = node.children.forEach((c) => {
          if (c.nodeType === 'Group'){
            try {              
              c.children.forEach((ch) => {
                if (ch.attrs.x){
                  if (ch.attrs.x > this.timeLine.points[0]){
                    ch.hide()
                  }
                  return
                }
                
                if (ch.attrs.points[2] > this.timeLine.points[0]){
                  ch.hide()
                }
              })
            } catch (error) {
              debugger
            }
            return
          }

          if (c.attrs.x > this.timeLine.points[0]){
              c.hide()
          }
        })

        node.draw()
        this.rightHided = !this.rightHided
      },
      changeTimeStatus() {
        if (this.timeIsPlaying) {
          this.$store.commit('stopTime')
        } else {
          this.$store.commit('startTime')
        }

        this.timeIsPlaying = !this.timeIsPlaying
      },
      readedClicked(event) {
        event.target.parentElement.hidden = true
      },
      redrawTrains() {
        const node = this.$refs.trainLayer.getNode()
        const trains = node.find('.train')

        trains.forEach((t) => {
          if (t.attrs.points[t.attrs.points.length - 2] < this.timeLine.points[0]) {
            t.setAttr('dash', [0, 0])
          } else {
            t.setAttr('dash', [10, 5])
          }
        })

        const fakeLine = node.findOne('#fake')

        if (fakeLine.attrs.points[fakeLine.attrs.points.length - 2] < this.timeLine.points[0]) {
          fakeLine.show()
          if (!this.snackbarShowed) {
            this.showSnackbar = true
            this.snackbarShowed = true
          }
        }
      },
      timeUpdated() {
        //debugger
        const currentTime = this.$store.getters.now
        this.currentDateTime = new Date(currentTime)

        if (this.lineEditingInProgress) {
          return
        }

        if (!this.$refs.trainLayer) {
          return
        }

        const timeClosestLine = this.verticalLines.filter(vt => vt.dateTimeInTicks > currentTime)[0]
        const minutes = this.currentDateTime.getMinutes() === 0 ? 1 : this.currentDateTime.getMinutes()
        const currentTimeInMilliseconds = minutes * 60000
        const result = currentTimeInMilliseconds * this.verticalPadding / this.ticksInHour

        if (result === 0 || timeClosestLine == null) {
          return
        }

        const timeLineX = timeClosestLine.points[0] - (this.verticalPadding - result)

        this.timeLine.points = []
        this.timeLine.points.push(timeLineX)
        this.timeLine.points.push(0)
        this.timeLine.points.push(timeLineX)
        this.timeLine.points.push(this.configKonva.height)
        this.redrawTrains()
        this.$refs.trainLayer.getNode().draw()
        
        if (currentTime === 1567303200000 || currentTime === 1567296000000){
          this.$store.commit('stopTime')
          this.timeIsPlaying = false
        }
      },
      formatDate(date, previousDate, isFirstDate) {
        if (date.getDate() !== previousDate.getDate() || isFirstDate) {
          return `${date.getHours()}:00 ${date.getDate()}.0${date.getMonth() + 1}`
        }
        return `${date.getHours()}:00`
      },
      click() {
        this.trainLines = this.trainLines.slice(this.trainLines.length)
        this.drawTrains()
      },
      fillHorizontalLines(padding) {
        this.topLineConfig = {
          points: [0, 0, this.configKonva.width, 0],
          stroke: '#607d8b',
          strokeWidth: 1
        }

        let yPosition = 50

        for (let i = 0; i < this.section.stations.length; i++) {
          const station = this.section.stations[i]
          yPosition += station.from * 15

          this.horizontalLines.push({
            points: [padding, yPosition, this.configKonva.width, yPosition],
            stroke: '#607d8b',
            strokeWidth: 0.5
          })
          const horizontalTextConfig = new Konva.Text({
            x: 10,
            y: yPosition + 20 - 5,
            text: station.name,
            fontSize: 12,
            id: station.code,
            fill: 'black',
          })
          this.horizontalText.push(horizontalTextConfig.attrs)
        }
      },
      createTooltip() {
        const tooltip = new Konva.Label({
          opacity: 0.75,
          visible: false,
          listening: false,
        })

        tooltip.add(new Konva.Tag({
          fill: 'black',
          pointerDirection: 'down',
          pointerWidth: 10,
          pointerHeight: 10,
          lineJoin: 'round',
          shadowColor: 'black',
          shadowBlur: 10,
          shadowOpacity: 0.2
        }))

        tooltip.add(new Konva.Text({
          text: '',
          fontFamily: 'Roboto',
          fontSize: 15,
          padding: 5,
          fill: 'white',
          lineHeight: 0.9
        }))

        this.$refs.trainLayer.getNode().add(tooltip)
        return tooltip
      },
      fillVerticalLines(padding) {
        let i = 1
        let cycle = 0

        for (let j = this.beginDateTicks; j < this.endDateTicks; j += this.ticksInHour) {
          const x = i * padding + this.fullDayHour * cycle

          this.verticalLines.push({
            points: [x, 0, x, this.configKonva.height],
            stroke: '#607d8b',
            strokeWidth: 0.7,
            dateTimeInTicks: j,
            id: `${j}`
          })
          let internalCounter = 1

          for (let s = x + 16.6; s < x + padding - 16.6; s += 16.6) {
            if (internalCounter === 3) {
              this.verticalLines.push({
                points: [s, 0, s, this.configKonva.height],
                stroke: '#607d8b',
                strokeWidth: 0.2,
                dash: [4, 2],
              })
            } else {
              this.verticalLines.push({
                points: [s, 0, s, this.configKonva.height],
                stroke: '#607d8b',
                strokeWidth: 0.2,
              })
            }
            internalCounter++
          }

          let leftShift = 7
          const text = this.formatDate(new Date(j), new Date(j - this.ticksInHour), j === this.beginDateTicks)

          if (text.length === 5) {
            leftShift = 12
          }

          const verticalTextConfig = new Konva.Text({
            x: (i * padding - leftShift) + (this.fullDayHour * cycle),
            y: 7,
            text: this.formatDate(new Date(j), new Date(j - this.ticksInHour), j === this.beginDateTicks),
            fontSize: 10,
            fill: 'black',
            fillEnabled: true,
          })
          this.verticalText.push(verticalTextConfig.attrs)
          i++

          if (i === 24) {
            i = 0
            cycle++
          }
        }
      },
      fillStations() {
        this.section.stations.push({
          index: 1,
          name: 'Астана 1',
          code: '690002',
          from: 0
        })
        this.section.stations.push({
          index: 2,
          name: 'Сороковая',
          code: '690200',
          from: 12.1
        })
        this.section.stations.push({
          index: 3,
          name: 'Обг. Пункт № 42',
          code: '690229',
          from: 24.3
        })
        this.section.stations.push({
          index: 4,
          name: 'Бабатай',
          code: '690303',
          from: 10.9
        })
        this.section.stations.push({
          index: 5,
          name: 'Шептыкуль',
          code: '690318',
          from: 7.35
        })
        this.section.stations.push({
          index: 6,
          name: 'Аршалы',
          code: '690407',
          from: 7.86
        })
        this.section.stations.push({
          index: 7,
          name: 'ОП 571 км',
          code: '673327',
          from: 12
        })
        this.section.stations.push({
          index: 8,
          name: 'Анар',
          code: '690500',
          from: 16
        })
        this.section.stations.push({
          index: 9,
          name: 'Сарыбел',
          code: '673609',
          from: 17
        })
        this.section.stations.push({
          index: 10,
          name: 'Актасты',
          code: '673505',
          from: 20
        })
        this.section.stations.push({
          index: 11,
          name: 'Шокай',
          code: '673401',
          from: 28
        })
        this.section.stations.push({
          index: 12,
          name: 'Астаховка',
          code: '673420',
          from: 17
        })
        this.section.stations.push({
          index: 13,
          name: 'Мырза',
          code: '673308',
          from: 10
        })
        this.section.stations.push({
          index: 14,
          name: 'Нура',
          code: '673204',
          from: 9.1
        })
        this.section.stations.push({
          index: 15,
          name: 'ПП №496',
          code: '673219',
          from: 5
        })
        this.section.stations.push({
          index: 16,
          name: 'Пп. 696 км',
          code: '673261',
          from: 5.3
        })
        this.section.stations.push({
          index: 17,
          name: 'Кокпекты',
          code: '673223',
          from: 4
        })
        this.section.stations.push({
          index: 18,
          name: 'Караганда-Сорт',
          code: '673007',
          from: 8.3
        })
      },
      fillTrains() {
        window.trains.forEach(train => {
          this.trains.push(train)
        });
      },
      getTooltipText(line) {

        let speed = ''
        if (line.attrs.trackSpanLength) {
          const speedOnTrackSpan = (line.attrs.trackSpanLength / (Number(
            `${line.attrs.moveTime.getMinutes()}.${line.attrs.moveTime.getSeconds()}`) / 60)).toFixed(2)
          speed = `Скорость на перегоне: ${speedOnTrackSpan}\n`
        }

        const lastArrival = moment(line.parent.children[line.parent.children.length - 1].attrs.arrival)
        const firstDeparture = moment(line.parent.children[0].attrs.departure)
        const diff = moment.duration(lastArrival.diff(firstDeparture))

        const speedOnSection = (this.section.length / Number(`${diff.hours()}.${diff.minutes()}`)).toFixed(2)

        speed += `Скорость на участке: ${speedOnSection}\n`

        // if (speedOnSection == 'NaN' || speedOnSection == 'Infinity'){
        //   window.wrongIds.push(line.attrs.train.id)
        // }

        let result =
          `Номер маршрута: ${line.attrs.train.number}\n` +
          `Вид движения: ${line.attrs.train.trafficKindName}\n` +
          `Тип поезда: ${line.attrs.train.trainTypeName}\n` +
          `Машинист: ${line.attrs.train.locoman}\n` +
          `Локомотив: ${line.attrs.train.locomotive}\n`

        if (line.attrs.train.locomotiveWarning) {
          result += `Предупреждения по локомотиву: ${line.attrs.train.locomotiveWarning}\n`
        }
        result += `Вес: ${line.attrs.train.trainInfo.grossWeight} тонн\n`
        result += `Вагоны: ${line.attrs.train.trainInfo.wagonInfo.join(';')}\n`
        result += speed

        return result

      },
      mouseOver(event) {
        if (this.lineEditingInProgress) {
          return
        }

        const line = event.target

        line.parent.children.forEach((l) => {
          l.setAttr('strokeWidth', 8)
        })

        line.parent.moveToTop()
        this.tooltip.moveToTop()

        this.tooltip.setAttr('visible', true)
        this.tooltip.setAttr('position', this.$refs.canvas.getNode().getPointerPosition())
        this.tooltip.findOne('Text').setAttr('text', this.getTooltipText(line))
        this.$refs.trainLayer.getNode().draw()
      },
      mouseout(event) {
        const line = event.target
        line.parent.children.forEach((l) => {
          l.setAttr('strokeWidth', 1.5)
        })
        this.tooltip.setAttr('visible', false)
        this.$refs.trainLayer.getNode().draw()
      },
      drawTrains() {
        const trainLayer = this.$refs.trainLayer.getNode()

        for (let i = 0; i < this.trains.length; i++) {
          const train = this.trains[i]

          let trainNumber = {
            text: train.number,
            fontSize: 10
          }

          const node = this.$refs.leftCanvas.getNode()
          const group = new Konva.Group()
          const stationStopLines = []
          const allLines = []

          group.on('mouseover', this.mouseOver)
          group.on('mouseout', this.mouseout)

          let color = window.colors[Math.floor(Math.random() * window.colors.length - 1) + 1]

          if (train.trafficKindName === 'Пассажирский') {
            color = '#ff0000'
          }

          if (train.trafficKindName === 'Хозяйственный') {
            continue
            color = 'green'
          }

          for (let j = 0; j < train.stationPasses.length; j++) {
            const stationPass = train.stationPasses[j]
            const stationEl = node.findOne(`#${stationPass.station.code}`)

            if (stationEl == null) {
              //console.log(`${train.id} ${train.number} ${stationPass.station.code}`)
              continue
            }

            const line = this.createStationLine(train, stationPass, stationEl, color)
            stationStopLines.push(line)
          }

          stationStopLines.reduce((p, c) => {
            let beginX = 0,
              beginY = 0
            let endX = 0,
              endY = 0

            if (p.attrs.points.length == 2) {
              beginX = p.attrs.points[0]
              beginY = p.attrs.points[1]
            } else {
              beginX = p.attrs.points[2]
              beginY = p.attrs.points[3]
            }

            endX = c.attrs.points[0]
            endY = c.attrs.points[1]

            if (!allLines.includes(p)) {
              allLines.push(p)
            }
            const trackSpanLine = this.createTrackSpanLine(p, c, train, beginX, beginY, endX, endY, color)
            allLines.push(trackSpanLine)

            if (!allLines.includes(c)) {
              allLines.push(c)
            }

            return c
          })

          const allLinesWithoutTracing = []

          allLines.forEach((l) => {
            if (l.attrs.points.length == 2) {
              allLinesWithoutTracing.push(l)
              return
            }

            if (l.attrs.points[0] == l.attrs.points[2] && l.attrs.points[1] == l.attrs.points[3]) {
              return
            }

            allLinesWithoutTracing.push(l)
          })

          allLinesWithoutTracing.forEach((el, i) => {
            let lines = []

            if (i === 0) {
              if (el.attrs.points[1] !== this.horizontalLines[0].points[1]) {
                let points = [el.attrs.points[0], el.attrs.points[1]]
                points.push(points[0] - 30, points[1])

                lines.push(new Konva.Line({
                  points: points,
                  stroke: color,
                  strokeWidth: 1.5,
                  scaleX: 1,
                  scaleY: 1,
                  draggable: false,
                  tension: 0,
                  closed: false,
                  train: train,
                }))
                lines.push(new Konva.Line({
                  points: points,
                  stroke: color,
                  strokeWidth: 1.5,
                  scaleX: 1,
                  scaleY: 1,
                  draggable: false,
                  tension: 0,
                  closed: false,
                  train: train,
                }))
              }
            }

            if (lines.length !== 0) {
              lines.forEach((l) => {
                group.add(l)
              })
            }

            if (i === allLinesWithoutTracing.length - 1) {
              if (el.attrs.points[1] !== this.horizontalLines[this.horizontalLines.length - 1].points[1]) {
                let points = [el.attrs.points[el.attrs.points.length - 2], el.attrs.points[el.attrs.points.length -
                  1]]
                points.push(points[0] + 30, points[1])

                lines.push(new Konva.Line({
                  points: points,
                  stroke: color,
                  strokeWidth: 1.5,
                  scaleX: 1,
                  scaleY: 1,
                  draggable: false,
                  tension: 0,
                  closed: false,
                  train: train,
                }))

                const firstY = allLinesWithoutTracing[0].attrs.points[1]
                const lastY = allLinesWithoutTracing[allLinesWithoutTracing.length - 1].attrs.points[
                  allLinesWithoutTracing[allLinesWithoutTracing.length - 1].attrs.points.length - 1]

                if (firstY < lastY) {
                  points = [points[0] + 30, points[1], points[0] + 30 + 20, points[1] + 20]
                } else {
                  points = [points[0] + 30, points[1], points[0] + 30 + 20, points[1] - 20]
                }

                lines.push(new Konva.Line({
                  points: points,
                  stroke: color,
                  strokeWidth: 1.5,
                  scaleX: 1,
                  scaleY: 1,
                  draggable: false,
                  tension: 0,
                  closed: false,
                  train: train,
                }))
              }
            }

            group.add(el)

            if (lines.length !== 0) {
              lines.forEach((l) => {
                group.add(l)
              })
            }
          })

          if (allLinesWithoutTracing.length === 0) {
            continue
          }

          const firstP = allLinesWithoutTracing[0].attrs.points[1]
          const lastP = allLinesWithoutTracing[allLinesWithoutTracing.length - 1].attrs.points[1]

          trainNumber.fill = color

          if (firstP <= lastP) {
            trainNumber.fill = this.shadeColor(color, 20)
            allLinesWithoutTracing.forEach((l) => l.attrs.stroke = trainNumber.fill)
            trainNumber.x = allLinesWithoutTracing[0].attrs.points[0] + 15
            trainNumber.y = allLinesWithoutTracing[0].attrs.points[1] + 15
            trainNumber.rotation = 70
          } else {
            trainNumber.fill = this.shadeColor(color, -40)
            allLinesWithoutTracing.forEach((l) => l.attrs.stroke = trainNumber.fill)
            trainNumber.x = allLinesWithoutTracing[0].attrs.points[0] - 15
            trainNumber.y = allLinesWithoutTracing[0].attrs.points[1] - 15
            trainNumber.rotation = -70
          }

          this.trainNames.push(trainNumber)

          trainLayer.add(group)
        }

        const groups = trainLayer.children.filter(c => c.getType() === 'Group')

        groups.forEach((g, i) => {
          if (i === 0) {
            return
          }

          const f = this.getTooltipText(g.children[0])

          const points = g.children.map(c => c.attrs.points)
          const firstPoint = points[0]
          const lastPoint = points[points.length - 1]

          if (firstPoint[0] - lastPoint[0] < 0) {
            for (let j = 0; j < points.length; j++) {
              const currentEl = points[j];
              const nextEl = points[j + 1];

              if (nextEl == null) {
                continue
              }

              if (currentEl[0] > nextEl[0]) {
                window.wrongIds.push(g.children[0].attrs.train.id)
              }
            }
          }

          if (firstPoint[0] - lastPoint[0] > 0) {
            for (let j = 0; j < points.length; j++) {
              const currentEl = points[j];
              const nextEl = points[j + 1];

              if (nextEl == null) {
                continue
              }

              if (currentEl[0] < nextEl[0]) {
                window.wrongIds.push(g.children[0].attrs.train.id)
              }
            }
          }
        })

        trainLayer.draw()
      },
      createStationLine(train, stationPass, stationEl, color) {
        let line = new Konva.Line({
          points: [],
          stroke: color,
          strokeWidth: 1.5,
          scaleX: 1,
          scaleY: 1,
          draggable: false,
          tension: 0,
          closed: false,
          train: train,
          name: 'train',
          stationCode: stationPass.station.code,
          arrival: stationPass.arrivalDateTime,
          departure: stationPass.departureDateTime,
        })

        if (train.number == '56') {
          line.on('lclick', this.lineClicked)
        } else {
          line.on('dblclick', this.lineSelected)
        }

        if (stationPass.arrival > 0) {
          const graterThenArrival = this.verticalLines.filter(vt => vt.dateTimeInTicks > stationPass.arrival)[0]

          const arrivalInMilliseconds = new Date(stationPass.arrival).getMinutes() * 60000
          const result = arrivalInMilliseconds * this.verticalPadding / this.ticksInHour

          line.attrs.points.push(graterThenArrival.points[0] - (this.verticalPadding - result))
          line.attrs.points.push(stationEl.attrs.y - 20 + 5)
        }

        if (stationPass.departure > 0) {
          const graterThenDeparture = this.verticalLines.filter(vt => vt.dateTimeInTicks > stationPass.departure)[0]

          const departureMilliseconds = new Date(stationPass.departure).getMinutes() * 60000
          const result = departureMilliseconds * this.verticalPadding / this.ticksInHour

          line.attrs.points.push(graterThenDeparture.points[0] - (this.verticalPadding - result))
          line.attrs.points.push(stationEl.attrs.y - 20 + 5)
        }

        return line;
      },
      createTrackSpanLine(previousStation, currentStation, train, beginX, beginY, endX, endY, color) {
        const trackSpanLength = this.section.stations.find(s => s.code == currentStation.attrs.stationCode).from

        let line = new Konva.Line({
          points: [beginX, beginY, endX, endY],
          stroke: color,
          strokeWidth: 1.5,
          scaleX: 1,
          scaleY: 1,
          draggable: false,
          tension: 0,
          closed: false,
          train: train,
          name: 'train',
          trackSpanLength: trackSpanLength,
          moveTime: new Date(new Date(currentStation.attrs.arrival) - new Date(previousStation.attrs.departure))
        })

        if (train.number == '56') {
          line.on('click', this.lineClicked)
        } else {
          line.on('dblclick', this.lineSelected)
        }
        return line
      },
      lineSelected(event) {
        if (this.lineEditingInProgress) {
          return
        }

        const clickedLine = event.target
        const trainLayerNode = this.$refs.trainLayer.getNode()

        trainLayerNode.children.forEach((group) => group.children.forEach((l) => l.hide()))

        const startCircle = new Konva.Circle({
          radius: 5,
          x: clickedLine.attrs.points[0],
          y: clickedLine.attrs.points[1],
          fill: 'red',
          draggable: true,
          dragBoundFunc: function (pos) {
            return {
              x: pos.x,
              y: clickedLine.attrs.points[1]
            }
          }
        })

        const endCircle = new Konva.Circle({
          radius: 5,
          x: clickedLine.attrs.points[2],
          y: clickedLine.attrs.points[3],
          fill: 'red',
          draggable: true,
          dragBoundFunc: function (pos) {
            return {
              x: pos.x,
              y: clickedLine.attrs.points[3]
            }
          }
        })

        startCircle.on('dragmove', () => {
          clickedLine.attrs.points[0] = startCircle.x()
          trainLayerNode.batchDraw()
        })

        endCircle.on('dragmove', () => {
          clickedLine.attrs.points[2] = endCircle.x()
          trainLayerNode.batchDraw()
        })

        trainLayerNode.add(startCircle)
        trainLayerNode.add(endCircle)

        const currentLineIndex = clickedLine.parent.children.indexOf(clickedLine)
        const previousLine = clickedLine.parent.children[currentLineIndex - 1]
        const nextLine = clickedLine.parent.children[currentLineIndex + 1]

        this.editor.previousLine.index = currentLineIndex - 1
        this.editor.previousLine.line = previousLine

        this.editor.currentLine.index = currentLineIndex
        this.editor.currentLine.line = clickedLine

        this.editor.nextLine.index = currentLineIndex + 1
        this.editor.nextLine.line = nextLine

        if (previousLine != null) {
          previousLine.show()
        }

        clickedLine.show()

        if (nextLine != null) {
          nextLine.show()
        }

        trainLayerNode.draw()
        this.lineEditingInProgress = true
      },
      cancelLineEditing() {
        this.endEditing()
      },
      acceptLineEditing() {
        this.applyChangesToNeighboringLines()
        this.endEditing()
      },
      endEditing() {
        const trainLayerNode = this.$refs.trainLayer.getNode()
        trainLayerNode.children.forEach((group) => group.children.forEach((l) => l.show()))
        trainLayerNode.find('Circle').forEach((c) => {
          c.destroy()
        })

        trainLayerNode.draw()
        this.lineEditingInProgress = false
      },
      applyChangesToNeighboringLines() {
        if (this.editor.previousLine.line) {
          this.editor.previousLine.line.attrs.points[2] = this.editor.currentLine.line.attrs.points[0]
          this.editor.previousLine.line.attrs.points[3] = this.editor.currentLine.line.attrs.points[1]
        }
        if (this.editor.nextLine.line) {
          this.editor.nextLine.line.attrs.points[0] = this.editor.currentLine.line.attrs.points[2]
          this.editor.nextLine.line.attrs.points[1] = this.editor.currentLine.line.attrs.points[3]
        }
      },
      calculateMinuteVerticalLine(dateTime) {
        const timeInMilliseconds = new Date(dateTime).getMinutes() * 60000
        return timeInMilliseconds * this.verticalPadding / this.ticksInHour
      },
      lineClicked() {
        this.train56WasClicked = !this.train56WasClicked
      },
      shadeColor(color, percent) {

        var R = parseInt(color.substring(1, 3), 16);
        var G = parseInt(color.substring(3, 5), 16);
        var B = parseInt(color.substring(5, 7), 16);

        R = parseInt(R * (100 + percent) / 100);
        G = parseInt(G * (100 + percent) / 100);
        B = parseInt(B * (100 + percent) / 100);

        R = (R < 255) ? R : 255;
        G = (G < 255) ? G : 255;
        B = (B < 255) ? B : 255;

        var RR = ((R.toString(16).length == 1) ? "0" + R.toString(16) : R.toString(16));
        var GG = ((G.toString(16).length == 1) ? "0" + G.toString(16) : G.toString(16));
        var BB = ((B.toString(16).length == 1) ? "0" + B.toString(16) : B.toString(16));

        return "#" + RR + GG + BB;
      }
    }
  }
</script>

<style>
  .active-menu-item {
    background-color: #cecece;
  }

  #container {
    padding: 0;
  }

  #column {
    padding-top: 0;
  }

  .rounded {
    border-radius: 50px !important;
  }

  #left-canvas {
    float: left;
    position: absolute;
    left: 0;
    top: 0;
  }

  #top-canvas {
    position: absolute;
    top: 0px;
  }

  #main-canvas {
    margin-top: 20px;
  }

  .small-line-brake {
    height: 2px;
    visibility: hidden;
    margin-bottom: -1px;
  }

  .left-align-text {
    text-align: start;
  }

  #rigth-tab>div.v-window.v-item-group.theme--light.v-tabs-items>div>div.v-window-item.v-window-item--active>div>div.v-card__title {
    font-size: 1.2rem;
  }

  #rigth-tab>div.v-window.v-item-group.theme--light.v-tabs-items>div>div.v-window-item.v-window-item--active>div>div.v-card__text {
    text-align: start;
  }

  #rigth-tab>div.v-window.v-item-group.theme--light.v-tabs-items>div>div.v-window-item.v-window-item--active>div>div.v-window.v-item-group.theme--light.v-tabs-items>div>div.v-window-item.v-window-item--active>div>div>div.v-list-item.v-list-item--link.v-list-item--two-line.theme--light>div.v-list-item__content>div.v-list-item__subtitle.left-align-text {
    text-align: start !important;
  }

  #rigth-tab>div.v-window.v-item-group.theme--light.v-tabs-items>div>div.v-window-item.v-window-item--active>div>div.v-window.v-item-group.theme--light.v-tabs-items>div>div.v-window-item.v-window-item--active>div>div>div>div.v-list-item__content>div.v-list-item__title.headline.left-align-text {
    font-size: 1.2rem !important;
  }
</style>